import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { formatText } from 'core/i18n';
import RARadioButtonStep from 'components/RAComponents/RARadioButtonStep/RARadioButtonStep';
import { RoadmapNavigation } from 'components/steps/roadmapNavigation';
import RAModal from 'components/RAComponents/commons/RAModal/RAModal';
import { SUITABILITY_TEST_STEP_4, SUITABILITY_TEST_PROFILE_MODEL_ANSWERS } from 'constants/RAConstants';
import sustainabilityHandIcon from 'assets/icons/icon-sustainability-hand.svg';
import './InvestmentFactors.scss';

const QUESTION_MODAL_REVIEW_ANSWERS_ID = 500;

export const InvestmentFactors = ({
    immSuitabilityTest,
    userProfile,
    formActions,
    raTestActions,
    RATestWizard,
    modalCancelActions,
    raSuitabilityTest,
}) => {
    const pointToScrollOnExtraQuestions = useRef(null);
    const [isInvestmentFactorsQuestionVisible, setInvestmentFactorsQuestionVisibility] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const answerQuestion402 = userProfile?.RASuitabilityTest.answers[402];

    const handleShowMoreInfo = () => {
        setInvestmentFactorsQuestionVisibility(
            isInvestmentFactorsQuestionVisible => !isInvestmentFactorsQuestionVisible
        );
    };

    useEffect(() => {
        if (answerQuestion402 === 'answer3') {
            pointToScrollOnExtraQuestions.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            handleShowMoreInfo();
        }
    }, [answerQuestion402]);

    const toggleModal = () => setShowModal(prevState => !prevState);

    const getCurrentStepAndSubStep = () => {
        const { currentStep, currentSubStep } = RATestWizard;

        return { currentStep, currentSubStep };
    };
    const renderQuestion = questionId => {
        const question = immSuitabilityTest.getIn(['questions', questionId]);
        const title = question.get('title');
        const answers = question.get('answers').toJS();
        const profileModel = `${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionId}`;

        return (
            <RARadioButtonStep
                disabled={false}
                formActions={formActions}
                profileModel={profileModel}
                radioButtons={answers}
                titleText={title}
                userProfile={userProfile}
                model={questionId}
                validateStep={() => {}}
                focusAnimated={false}
                step={SUITABILITY_TEST_STEP_4}
                onClickTooltip={() => {}}
            />
        );
    };

    const renderExtraBlockQuestions = () => {
        const questionsToRender = ['403', '404', '405'];

        return <div>{questionsToRender.map(questionId => renderQuestion(questionId))}</div>;
    };

    const onHandlePrevButton = () => {
        raTestActions.prevStep(getCurrentStepAndSubStep());
    };

    const onHandleCancelButton = () => {
        modalCancelActions.showModalCancel();
    };

    const shouldShowExtraBlockQuestion = () => answerQuestion402 === 'answer3';

    const isFirstQuestionAnsweredWithFirstOrSecondAnswer = () =>
        answerQuestion402 === 'answer1' || answerQuestion402 === 'answer2';

    const areExtraBlockQuestionsAnswered = () => {
        const answerQuestion403 = userProfile?.RASuitabilityTest.answers[403];
        const answerQuestion404 = userProfile?.RASuitabilityTest.answers[404];
        const answerQuestion405 = userProfile?.RASuitabilityTest.answers[405];

        return !!answerQuestion403 && !!answerQuestion404 && !!answerQuestion405;
    };

    const are404And405AnsweredWithBOrC = () => {
        const answerQuestion404 = userProfile?.RASuitabilityTest.answers[404];
        const answerQuestion405 = userProfile?.RASuitabilityTest.answers[405];

        return (
            answerQuestion404 === 'answer2' ||
            answerQuestion404 === 'answer3' ||
            answerQuestion405 === 'answer2' ||
            answerQuestion405 === 'answer3'
        );
    };

    const isFinalizeButtonDisabled = () => {
        return !(isFirstQuestionAnsweredWithFirstOrSecondAnswer() || areExtraBlockQuestionsAnswered());
    };

    const onClickContinueButton = () => {
        raSuitabilityTest.sendLogs();
        if (isFirstQuestionAnsweredWithFirstOrSecondAnswer() || !are404And405AnsweredWithBOrC() || showModal) {
            return raSuitabilityTest.sendTest(userProfile.accessToken);
        }

        return toggleModal();
    };

    const onClickContinueButtonModal = () => {
        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${QUESTION_MODAL_REVIEW_ANSWERS_ID}`, 'answer2');
        onClickContinueButton();
    };

    const onClickUnderstoodButton = () => {
        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${QUESTION_MODAL_REVIEW_ANSWERS_ID}`, 'answer1');
        raSuitabilityTest.sendLogs();
        toggleModal();
    };

    const arrowClass = classNames('icons', {
        'icons--icon-arrow-up': isInvestmentFactorsQuestionVisible,
        'icons--icon-arrow-down': !isInvestmentFactorsQuestionVisible,
    });

    const investmentFactorsQuestionClass = isInvestmentFactorsQuestionVisible ? 'fade-in' : 'fade-out';
    const showInfoMessage = isInvestmentFactorsQuestionVisible
        ? 'sustainability-showLessInfo'
        : 'sustainability-showMoreInfo';

    return (
        <main className="ra-sustainability investement-factors">
            <section className="investement-factors-info-wrapper">
                <div className="investement-factors-icon-wrapper">
                    <img src={sustainabilityHandIcon} alt="question mark" className="sustainability-hand" />
                </div>
                <div>
                    <p>{formatText('sustainability-factorText')}</p>
                    <ul>
                        <li>{formatText('sustainability-factorItem1')}</li>
                        <li>{formatText('sustainability-factorItem2')}</li>
                        <li>{formatText('sustainability-factortem3')}</li>
                    </ul>
                </div>
            </section>
            <section
                ref={pointToScrollOnExtraQuestions}
                className={`investement-factors-question ${investmentFactorsQuestionClass}`}
            >
                {renderQuestion('402')}
            </section>
            <hr />

            {shouldShowExtraBlockQuestion() && (
                <>
                    <div className="investement-factors-show-more-info">
                        <div onClick={handleShowMoreInfo}>
                            {formatText(showInfoMessage)} <span className={arrowClass}></span>
                        </div>
                    </div>
                    <section className="investement-factors-extra-question">{renderExtraBlockQuestions()}</section>
                </>
            )}

            <RAModal
                title={formatText('sustainability-modalStrategyTitle')}
                text={formatText('sustainability-modalStrategyText')}
                secondButton={formatText('button-reviewAnswers')}
                secondAction={onClickUnderstoodButton}
                firstButton={formatText('button-continue')}
                firstAction={onClickContinueButtonModal}
                show={showModal}
                hide={toggleModal}
            />
            <div className="steps-view__footer">
                <RoadmapNavigation
                    buttonPrevHidden={false}
                    buttonPrevText={formatText('suitabilityTest-prev')}
                    buttonCancelText={formatText('suitabilityTest-getOut')}
                    buttonPrevAction={onHandlePrevButton}
                    buttonCancelAction={onHandleCancelButton}
                    buttonContinueAction={onClickContinueButton}
                    buttonFinalizeHidden={false}
                    buttonFinalizeText={formatText('button-finalize')}
                    buttonFinalizeDisabled={isFinalizeButtonDisabled()}
                />
            </div>
        </main>
    );
};
